import { render, staticRenderFns } from "./ExpertSearch.vue?vue&type=template&id=863b2248&scoped=true&"
import script from "./ExpertSearch.vue?vue&type=script&lang=js&"
export * from "./ExpertSearch.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/expert.css?vue&type=style&index=0&id=863b2248&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863b2248",
  null
  
)

export default component.exports